import {
  createEconnectorClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

import { CentralSystem, CreateCentralSystem } from './model';

const client = createEconnectorClient('/api/centralsystems');

export const centralSystemPermissions = {
  SEARCH: 'econnector.search-central-systems',
  GET: 'econnector.get-central-system',
  CREATE: 'econnector.create-central-system',
  UPDATE: 'econnector.update-central-system',
  DELETE: 'econnector.delete-central-system'
};

export const searchCentralSystems: SearchOperation<CentralSystem> = searchRequestFactory<CentralSystem>(client, {
  permissionId: centralSystemPermissions.SEARCH
});

export const getCentralSystem: FindOperation<CentralSystem, string> = getRequestFactory<CentralSystem, string>(client, {
  permissionId: centralSystemPermissions.GET
});

export const createCentralSystem: SaveOperation<CreateCentralSystem> = postRequestFactory<CreateCentralSystem, CentralSystem>(client, {
  pattern: '',
  permissionId: centralSystemPermissions.CREATE
});

export const updateCentralSystem: SaveOperation<CentralSystem> = putRequestFactory<CentralSystem, CentralSystem>(client, {
  permissionId: centralSystemPermissions.UPDATE
});

export const deleteCentralSystem: DeleteOperation<CentralSystem, void> = deleteRequestFactory<CentralSystem, void>(client, {
  permissionId: centralSystemPermissions.DELETE
});
